import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import fp from 'lodash/fp';
import { withClient } from '@deerplusofficial/pos-hoc';
import {
  mapState,
  getResult,
  createCancelToken,
} from '@deerplusofficial/pos-helper';
import actions from '../../actions';
import withQueryPreOrders from '../Queries/withQueryPreOrders';

const {
  detail: { update },
} = actions.preOrder;

export default config => Component =>
  fp.compose(
    withClient(),
    withQueryPreOrders(),
    connect(
      mapState(['preOrder', 'cart', 'order']),
      { update }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithCreatePreOrder');

      state = {
        isPreOrderMutating: false,
      };

      componentWillUnmount() {
        !_.isUndefined(this.cancelMutation) && this.cancelMutation();
      }

      onPreOrderMutate = async () => {
        const {
          update,
          fetchPreOrders,
          cart: { items },
          preOrder: { name, description, id },
          order: { customPrice, discount },
          client: { POSApi, onError },
        } = this.props;

        const data = {
          name,
          description,
          meta: JSON.stringify({
            cart: { items },
            order: { customPrice, discount },
          }),
        };

        try {
          this.setState({ isPreOrderMutating: true });
          if (id) {
            await POSApi.put(`/pre_orders/${id}`, data, {
              cancelToken: createCancelToken(this.cancelMutation),
            });
            update({ isSaved: true });
            fetchPreOrders();
            return;
          }
          const { id: freshId } = getResult(
            await POSApi.post('/pre_orders', data, {
              cancelToken: createCancelToken(this.cancelMutation),
            })
          );
          update({ id: freshId, isSaved: true });
          fetchPreOrders();
        } catch (error) {
          onError(error);
        } finally {
          this.setState({ isPreOrderMutating: false });
        }
      };

      render() {
        return (
          <Component
            {...this.props}
            {...this.state}
            onPreOrderMutate={this.onPreOrderMutate}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withMutatePreOrder.js